<template>
  <settings-modal
    class="payment-manual-return-modal"
  >
    <template slot="heading">Accept payment {{ paymentId }} for manual return?</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentManualReturnModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        acceptForManualReturnApiRequest: new ApiRequest(PaymentApi.acceptForManualReturnByAml)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      loading () {
        return this.acceptForManualReturnApiRequest.loading
      },
      error () {
        return this.acceptForManualReturnApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.acceptForManualReturnApiRequest
          .execute(this.paymentId)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment has been successfully accepted for manual return.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
